import { defineSlotRecipe } from '@chakra-ui/react/styled-system'

import { EColors } from '../types'

const { titanWhite, buttonSecondary, mysteryLightBlue } = EColors

export const accordionSlotRecipe = defineSlotRecipe({
  className: 'chakra-accordion',
  slots: [
    'root',
    'item',
    'itemTrigger',
    'itemIndicator',
    'itemContent',
    'itemBody',
  ],
  base: {
    root: {
      width: 'full',
    },
    item: {
      border: 'none',
    },
    itemTrigger: {
      border: 'none',
      width: 'full',
      _hover: {
        bg: 'transparent',
      },
      _expanded: {
        bg: 'transparent',
      },
      _focus: {
        bg: 'transparent',
      },
    },
    itemContent: {
      overflow: 'hidden',
    },
    itemBody: {
      padding: '0',
    },
  },
  variants: {
    variant: {
      'gray-round': {
        item: {
          background: buttonSecondary,
          border: 'none',
          borderRadius: '16px',
        },
        itemTrigger: {
          borderBottom: 'none',
          padding: '12px',
          margin: '0',
        },
        itemBody: {
          padding: '0 12px 12px',
          margin: '0',
        },
      },
      mystery: {
        item: {
          background: 'transparent',
          border: 'none',
          borderRadius: '0',
        },
        itemTrigger: {
          borderBottom: `1px solid ${mysteryLightBlue}`,
          padding: '16px 0',
          margin: '0',
        },
        itemBody: {
          padding: '0 0 16px',
          margin: '0',
          borderBottom: `1px solid ${mysteryLightBlue}`,
        },
      },
      certificates: {
        item: {
          borderBottom: `1px solid ${titanWhite}`,
        },
        itemTrigger: {
          paddingLeft: 0,
          paddingRight: 0,
          borderBottom: 'none',
          marginTop: '8px',
        },
        itemBody: {
          listStyleType: 'unset',
          fontSize: '13px',
          fontWeight: 400,
          lineHeight: '16px',
          color: EColors.black,
          padding: '0 0 16px',
        },
      },
      spring: {
        item: {
          borderBottom: '1px solid var(--color-border-accordion)',
          _last: {
            borderBottom: 'none',
            marginBottom: '-16px',
          },
        },
        itemTrigger: {
          padding: '16px 0',
          borderBottom: 'none',
          fontSize: '15px',
          _icon: { svg: { fill: 'var(--color-text-tertiary)' } },
        },
        itemBody: {
          fontSize: '13px',
          fontWeight: 400,
          lineHeight: '16px',
          color: 'var(--color-text-accordion)',
          padding: '0 0 16px',
        },
      },
    },
  },
  defaultVariants: {
    variant: undefined,
  },
})
